// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/base.css
// module id = 5+O1
// module chunks = 14